<template>
    <div class="bg">
      <div class="banner">
          <img src="../../assets/goyb02.png" alt="">
      </div>
      <div class="bg-con">
            <div class="title">
                <h2 class="title1">{{ this.getInfoById.mainTitle }}</h2>
                <div v-if="this.getInfoById.subTitle">
                    <p class="title2">——{{ this.getInfoById.subTitle }}</p>
                </div>
                <div style="font-weight: 400;margin-top: 10px;">发布日期：{{this.getInfoById.publicationDate.substring(0, 10)}}</div>
            </div>
            <hr>
            <div class="main">
        <!-- <div class="content">
            <p>在刚刚结束的第九届国际青年名厨盛宴比赛中，郑州翼博餐饮企业管理有限公司的杰出项目经理张文举先生凭借卓越的表现，荣获了“年度国际中餐最佳星厨”的崇高荣誉。这一成就不仅彰显了张文举先生个人的非凡才华，也极大地鼓舞了郑州翼博餐饮企业管理有限公司的全体厨师团队。</p>
            <div class="new_img1"><img src="../../assets/goyb/o1.png" alt=""></div>
            <p>本次国际青年名厨盛宴，作为餐饮界的一项盛事，吸引了全球众多青年才俊同台竞技。张文举先生以其深厚的烹饪功底、独特的创意理念以及对中餐文化的深刻理解，在众多参赛者中脱颖而出，赢得了评委和观众的高度赞誉。他的每一道菜品都仿佛是一幅精美的艺术品，不仅味道绝佳，更蕴含着丰富的文化内涵和创意灵感。</p>
            <div class="new_img1"><img src="../../assets/goyb/o2.png" alt=""></div>
            <p>郑州翼博餐饮企业管理有限公司对于张文举先生的获奖表示了热烈的祝贺，并高度评价了他所展现出的学习精神和竞技精神。公司副总经理杨天龙表示：“张文举先生的获奖是我们公司的骄傲，也是我们全体员工的榜样。我们将继续支持并鼓励厨师团队参与国内外各类烹饪比赛，通过不断的学习和实践，提升公司的整体烹饪水平，为顾客提供更加优质的餐饮服务。”</p>
            <div class="new_img1"><img src="../../assets/goyb/o3.png" alt=""></div>
            <p>此次获奖不仅为郑州翼博餐饮企业管理有限公司增添了光彩，也为中餐文化的国际传播做出了积极贡献。张文举先生的故事将激励更多年轻厨师投身于烹饪事业，共同推动中餐行业的繁荣发展。</p>
        </div> -->
        <div class="content" v-html="this.getInfoById.content">
        </div>
        <hr>
        <div class="new_next">
        <router-link to="/home" v-if="this.getInfoById.type === '4'">
            <div class="new_right">返回首页</div>
        </router-link>
        <router-link to="/honor/myzs6" v-else>
            <div class="new_right">返回列表</div>
        </router-link>
        </div>
    </div>
      </div>
      
    </div>
  </template>
  
<script>
import { mapActions, mapState } from 'vuex'
export default {
    data(){
        return{
            id:localStorage.getItem('id')-0
        }
    },
    computed:{
        ...mapState('myZs6',['getInfoById'])
    },
    created(){
        this.getInfoByIdAction(this.id)
    },
    mounted(){
        this.$router.afterEach((to, from, next) => {
            window.scrollTo(0, 0)
        })
    },
    methods:{
        ...mapActions('myZs6',['getInfoByIdAction']),
    }
}
  </script>
  
  <style scoped>
  .banner{
      width: 100%;
      height: 3rem;
      overflow: hidden;
  }
  .banner:hover img{
      transform: scale(1.2);
  }
  .banner img{
      transition: all .4s;
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
  }
  .yy-box1{
    margin: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #f6f6f6;
}
  
  /* 标题 */
  /* 标题 */
.title{
    margin: 20px 0px;
    position: relative;
    height: 70px;
}
.title1{
    font-size: .13rem;
}
.title2{
    font-size: 22px;
    position: absolute;
    top: 15px;
    left: 1000px;
}
hr{
    width: 60%;
    margin: 0 auto;
}
.main{
    width: 96%;
    /* background-color: pink; */
    margin: .1rem auto;
}
.content p{
    text-indent:2em;
    text-align: left;
    font-size: .1rem;
    line-height: .23rem;
}
.content .a1{
    text-align: center;
    font-weight: 700;
}
.new_img1{
    width: 800px;
    height: 400px;
    margin: 5px auto;
}
.new_img1 img{
    width: 100%;
    height: 100%;
}
/* 翻篇 */
.new_next{
    width: 100%;
    /* height: 2rem; */
    /* margin-top: .2rem; */
    /* background-color: pink; */
    font-size: .09rem;
    text-align: left;
}
/* .new_next .new_left, */
.new_next .new_right{
    padding:.09rem 0;
}
.new_next .new_right:hover{
    color: red;
}
.main hr{
    width: 100%;
    margin-top: .2rem;
}
.bg {
    background-image: url('../../assets/bg.jpg');
    background-repeat: repeat;
    background-size: 50% auto;
}
.bg-con {
    background: #fff;
    width: 66%;
    margin-left: 17%;
    padding-top: 20px;    
}
  </style>